import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { EmptyState, EmptyText } from 'components/customer/answer_panel/lib/empty_state';
import MagnifyingGlassIcon from 'components/lib/icons/magnifying_glass_icon';

export default function PlaceholderAnswerSearch() {
  const { t } = useTranslation();
  return (
    <Placeholder data-aid="placeholderAnswerSearch">
      <MagnifyingGlassIcon />
      <EmptyText>{t('Search Answers')}</EmptyText>
    </Placeholder>
  );
}

const Placeholder = styled(EmptyState)`
  .magnifyingGlassIcon {
    height: 60px;
    width: 60px;
  }
  .magnifyingGlassIcon-circle {
    fill: ${p => p.theme.colors.gray100};
  }
  .magnifyingGlassIcon-stroke {
    stroke: ${p => p.theme.colors.green400};
  }
`;
